import { useState, useEffect, useContext, useCallback, useMemo, useRef } from 'react';
import { BatteryHorizIcon, MeterIcon, PcsIcon, PvIcon, IconLabel, ElecLine } from '../service/SvgIcons';

/**
 * Herit 3사이트를 위한 Single Line 
 * @param {*} props 
 * @param {Map} props.objmap 실시간으로 전달되는 장치 정보
 * @param {string} props.site Site ID
 * @param {Object} props.siteInfo site.hjson의 site 정보 
 * @returns 
 */
export function SingleLineSvgHerit(props) {
    // props.objmap
    // props.site
    // props.siteInfo
    const ix0 = 125; // meter x 위치
    const ix1 = 580; // pcs x 위치 
    const ix2 = 820; // bat x 위치
    const iy0 = 50;
    const iy1 = 320;
    const iy11 = iy1-75;
    const iy12 = iy1+75;
    const iy2 = 385;
    const iw = 75;  // icon width
    const ih = 75;  // icon height
    const jx = 430;  // joint x
    const jx2 = (ix1+ix2)/2+40;  // battery joint
    const fs = 24;  // font size

    const [pcs1Obj, setPcs1Obj] = useState(null);
    const [pcs2Obj, setPcs2Obj] = useState(null);
    const [pvObj, setPvObj] = useState(null);
    const [batObj, setBatObj] = useState(null);
    const [meterObj, setMeterObj] = useState(null);

    useEffect(() => {
        //console.dir(props.objmap);
        if (!props?.objmap) return;
        setPcs1Obj(props.objmap.get('pcs1/1/pcs'));
        setPcs2Obj(props.objmap.get('pcs2/2/pcs'));
        if (props.site === "hayan") {
            setPvObj(props.objmap.get('mq/2/meter/ch1'));
        } else {
            setPvObj(props.objmap.get('mq/3/inverter'));
        }
        setBatObj(props.objmap.get('bat/1/bms'));
        setMeterObj(props.objmap.get('mq/1/meter/ch1'));
    }, [props.objmap]);

    return (
        <svg width="100%" height="100%" viewBox="0 0 1024 526">
            <g>
                {/*
                <ElecLine path={[ix1, iy0+ih/2, jx, iy0+ih/2, jx, iy1+ih/2]} obj={gensetObj} power="+power"/>              
                <GensetIcon x={ix1} y={iy0} w={iw} h={ih}/>
                <IconLabel x={ix1} y={iy0+ih+fs} h={fs} type="ac" obj={gensetObj}/>*/}

                <ElecLine path={[ix1, iy0+ih/2, jx, iy0+ih/2, jx, iy1+ih/2, ix0+iw, iy1+ih/2]} obj={pvObj} />
                <PcsIcon x={ix1} y={iy0} w={iw} h={ih}/>
                <IconLabel x={ix1} y={iy0+ih+fs} h={fs} type="ac" obj={pvObj}/>
                <ElecLine path={[ix2, iy0+ih/2, ix1+iw, iy0+ih/2]} obj={pvObj} cb="-"/>              
                <PvIcon x={ix2} y={iy0} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iy0+ih+fs} h={fs} type="pv" obj={pvObj}/>

                <ElecLine path={[ix1, iy11+ih/2, jx, iy11+ih/2, jx, iy1+ih/2, ix0+iw, iy1+ih/2]} obj={pcs1Obj} power="+power"/>              
                <PcsIcon x={ix1} y={iy11} w={iw} h={ih}/>
                <IconLabel x={ix1} y={iy11+ih+fs} h={fs} type="ac" obj={pcs1Obj}/>

                <ElecLine path={[ix1, iy12+ih/2, jx, iy12+ih/2, jx, iy1+ih/2, ix0+iw, iy1+ih/2]} obj={pcs2Obj} power="+power"/>              
                <PcsIcon x={ix1} y={iy12} w={iw} h={ih}/>
                <IconLabel x={ix1} y={iy12+ih+fs} h={fs} type="ac" obj={pcs2Obj}/>

                <ElecLine path={[ix2, iy1+ih/2, jx2, iy1+ih/2, jx2, iy11+ih/2, ix1+iw, iy11+ih/2]} obj={pcs1Obj} cb="-"/>
                <ElecLine path={[ix2, iy1+ih/2, jx2, iy1+ih/2, jx2, iy12+ih/2, ix1+iw, iy12+ih/2]} obj={pcs2Obj} cb="-"/>
                <BatteryHorizIcon x={ix2} y={iy1} w={iw} h={ih}/>
                <IconLabel x={ix2} y={iy1+ih+fs} h={fs} type="bat" obj={batObj}/>

                <MeterIcon x={ix0} y={iy1} w={iw} h={ih}/>
                {/*<ElecLine path={[ix0+iw, iy1+ih/2, jx, iy1+ih/2]} obj={meterObj} power="-power"/>*/}
                <IconLabel x={ix0} y={iy1+ih+fs} h={fs} type="ac" obj={meterObj}/>          
            </g>
        </svg>
    );
}
